import axios, { CancelTokenSource } from 'axios';
import Input, { StyledInput } from 'components/final-form/Input';
import FormButtonsRow from 'components/layout/FormButtonsRow';
import FormContainer from 'components/layout/FormContainer';
import FormContent from 'components/layout/FormContent';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import LoaderComponent from 'components/LoaderComponent';
import MSNTCodeActionButton from 'components/patient-entry/bookings-table/MSNTCodeActionButton';
import { FormState } from 'final-form';
import React, { Component } from 'react';
import { Field, Form as FinalForm, FormSpy } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Icon } from 'semantic-ui-react';
import { generateMSNTCode } from 'services/patientCentralServices';
import styled from 'styled-components';
import { debounce } from 'ts-debounce';
import { mustBeNumber } from 'utils/validatorUtils';

const UpsertResourcesFormContent = styled(FormContent)`
  max-width: 600px;
`;

const initialMsntCodeValues: Partial<any> = {
  prefix: ""
}

interface MsntCodeFieldProps extends FormState {
  values: Partial<any>
}

interface Props extends MessageSourceProps {
  onCancel: () => void,
}

interface State {
  cancelTokenSource: CancelTokenSource,
  msntCode: string,
  prefix: string,
  codeLoaded: boolean
}

class UpsertRandomMSNTGeneratorForm extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      cancelTokenSource,
      msntCode: "",
      prefix: "",
      codeLoaded: false
    }
  }

  generateMSNTCode = (prefix: string) => {

    const {cancelTokenSource} = this.state;

    this.setState({
      codeLoaded: false
    });

    generateMSNTCode(prefix, cancelTokenSource)
        .then(response => {
          this.setState({
            msntCode: response
          })
        })
        .finally(() => {
          this.setState({
            codeLoaded: true
          })
        })

  }

  handleChange = debounce(({values}: MsntCodeFieldProps): void => {

    this.setState({
      prefix: values.prefix
    })

    this.generateMSNTCode(values.prefix);
  }, 300);

  renderMsntCodeGenerator = (): JSX.Element => {
    return (
        <FinalForm
            onSubmit={() => {
            }}
            initialValues={initialMsntCodeValues}
            subscription={{pristine: true}}
            render={this.renderForm}
        />
    );
  }

  formattedMsntCode = (msntCode: string): React.ReactNode => {

    return msntCode.slice(0, 4) + "-" + msntCode.slice(4, 8) + "-" + msntCode.slice(8, 12) + "-"
        + msntCode.slice(12, 16) + "-" + msntCode.slice(16, 20);
  }

  renderForm = (): React.ReactNode => {
    const {
      onCancel,
      getMessage

    } = this.props;
    const {msntCode, prefix, codeLoaded} = this.state;

    return (
        <>
          <FormContainer>
            <UpsertResourcesFormContent>
              {
                !codeLoaded &&
                  <LoaderComponent message={getMessage("loading")}/>
              }

              <PraxFormGrid>
                <Grid.Row>
                  <Grid.Column width={4} verticalAlign="middle">
                    {getMessage("patientCentral.msntRandomCodeGenerator.prefix")}
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <Field
                        name="prefix"
                        component={Input}
                        fluid
                        lenght={15}
                        validate={mustBeNumber}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={4}>
                    {getMessage("patientCentral.msntRandomCodeGenerator.description")}
                  </Grid.Column>
                  <Grid.Column width={7} verticalAlign={'middle'}>
                    <StyledInput
                        value={msntCode}
                        readOnly
                        fluid
                    />
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign={'middle'}>
                    <MSNTCodeActionButton
                        hoverMessage={getMessage("patientCentral.overview.actions.resetRandomMSNTCode")}
                        trigger={<Icon name={'refresh'}/>}
                        onConfirm={() => this.generateMSNTCode(prefix)}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={4}>
                  </Grid.Column>
                  <Grid.Column width={7} verticalAlign={'middle'}>
                    <StyledInput
                        value={this.formattedMsntCode(msntCode)}
                        readOnly
                        fluid
                    />
                  </Grid.Column>
                </Grid.Row>
              </PraxFormGrid>
              <FormSpy subscription={{values: true}} onChange={this.handleChange}/>
            </UpsertResourcesFormContent>

            <FormButtonsRow>
              <Button compact type="button"
                      onClick={onCancel}
              >
                {getMessage("patientCentral.msntRandomCodeGenerator.button.cancel")}
              </Button>
            </FormButtonsRow>
          </FormContainer>
        </>
    )
  }

  render(): React.ReactNode {
    return this.renderMsntCodeGenerator();
  }

}

export default withMessages(UpsertRandomMSNTGeneratorForm);
